import { guardClient } from '../_axios'

/**
 * 会社情報の更新
 * [patch]/company/{id}
 */

type Sales = {
  firstName?: string
  lastName: string
  department?: string
  post?: string
  cellPhone?: string
  mail: string
}
export type UpdateRequestType = {
  id: number
  name: string
  frequencyCode?: string
  tagCode?: string
  specialty?: string
  specialtyIndustry?: string
  postCode?: string
  address?: string
  homePhone?: string | null
  homepage?: string
  establishment?: string
  invoice?: string
  salesValue?: number
  properValue?: number
  bpValue?: number
  deliverAddress?: string
  dispatchLicense: boolean | null
  dispatchLicenseNumber?: string
  pMark: boolean | null
  isms: boolean | null
  memo?: string
  focusCustomer?: boolean
  version: string
  sales: Sales[]
}
export const updateCompany = async (request: UpdateRequestType) => {
  const { id, ...params } = request
  const updateData = {
    name: params.name,
    frequencyCode: params.frequencyCode,
    tagCode: params.tagCode,
    specialty: params.specialty,
    specialtyIndustry: params.specialtyIndustry,
    postCode: params.postCode,
    address: params.address,
    homePhone: params.homePhone,
    homepage: params.homepage,
    establishment: params.establishment,
    invoice: params.invoice,
    salesValue: Number(params.salesValue),
    properValue: Number(params.properValue),
    bpValue: Number(params.bpValue),
    deliverAddress: params.deliverAddress,
    dispatchLicense: params.dispatchLicense,
    dispatchLicenseNumber: params.dispatchLicenseNumber,
    pMark: params.pMark,
    isms: params.isms,
    memo: params.memo,
    focusCustomer: params.focusCustomer,
    version: params.version,
    sales: params.sales
  }
  const path = '/company'
  const response = await guardClient.patch(path + '/' + id, updateData)
  return response.data
}
